var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNorton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.022,
    height: 25.348,
    viewBox: "0 0 47.022 25.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-3{fill:#0a79c4}.cls-5{fill:#76838b}.cls-10{fill:#75828a}.cls-17{fill:#1880c8}.cls-29{fill:#2889cb}.cls-32{fill:#fefefe}.cls-37{fill:#fcfcfc}.cls-46{fill:#1e1e1c}.cls-48{fill:#cb9e06}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2853",
    transform: "translate(-215.469 -231.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    fill: "#fbc100",
    d: "M227.469 252.188a8.738 8.738 0 0 1-7.616-.439 8.576 8.576 0 0 1 6.719-15.677l.694.209c.675.151 1.384.241 1.693 1.008-.081.244-.2.469-.3.705a.72.72 0 0 1-.161.149c-.435.377-.548 1.005-1.054 1.337-.156.1-.26.262-.476.172a4.044 4.044 0 0 0-3.541-.922 5.577 5.577 0 1 0 2.418 10.827 5.471 5.471 0 0 0 3.8-4.866 5.413 5.413 0 0 0-.574-2.891c-.13-.289-.357-.553-.218-.906a14.4 14.4 0 0 0 1.346-1.861c.109-.2.233-.355.492-.3a2.9 2.9 0 0 1 1.14 1.42 8.805 8.805 0 0 1-2.946 11.47 4.046 4.046 0 0 1-1.416.565z",
    transform: "translate(0 -1.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3190",
    fill: "#abb6bf",
    d: "M233.307 252.212l1.227-.647a3.88 3.88 0 0 1 1.584-.226h23.805a7.047 7.047 0 0 0 6.271-3.165 6.992 6.992 0 0 0-5.676-10.863c-7.02-.038-14.041-.011-21.061-.015a4.111 4.111 0 0 1-1.36-.1.475.475 0 0 1-.213-.178.654.654 0 0 1-.031-.511c.088-.237.367-.242.507-.418a1.817 1.817 0 0 1 .25-.322c.159.526.568.512 1.013.511 6.7-.008 13.394-.022 20.092 0a8.182 8.182 0 0 1 7.26 3.586 7.952 7.952 0 0 1-4.8 12.175 4.941 4.941 0 0 1-1.109.175q-13.881.012-27.759-.002z",
    transform: "translate(-5.838 -1.335)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    d: "M265.015 264.413c0 .79.05 1.512-.012 2.224-.087 1-1 1.351-2.057.746.482-.395 1.507.279 1.55-.84-.531.242-1.051.309-1.442-.192a1.305 1.305 0 0 1-.106-1.512c.508-.926 1.326-.249 2.067-.426z",
    className: "cls-3",
    transform: "translate(-15.477 -10.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3192",
    fill: "#0877c4",
    d: "M260 266.268c-.294.164-.475-.1-.746.01a.906.906 0 0 1-1.253-.366 1.4 1.4 0 0 1 .026-1.524.968.968 0 0 1 1.267-.376.642.642 0 0 0 .188.021c.259-.276-.2-.866.519-.951z",
    transform: "translate(-13.851 -10.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3193",
    d: "M249.683 263.012c.584.254.229.716.459.976 1.119-.046 1.458.255 1.425 1.269-.031.977-.28 1.111-1.884.992z",
    className: "cls-5",
    transform: "translate(-11.198 -10.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3194",
    fill: "#748289",
    d: "M232.859 266.916c-.6-.515-.474-1.156-.848-1.56-.315.449-.248 1.044-.745 1.526a11.106 11.106 0 0 1-.768-2.529c.731.375.527 1.025.835 1.46.373-.359.211-1.01.676-1.362.548.3.32.995.731 1.391.3-.418.106-1.053.759-1.5a12.986 12.986 0 0 1-.64 2.574z",
    transform: "translate(-4.918 -10.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3195",
    fill: "#74828a",
    d: "M245.685 264.018c.2-.345-.1-.783.462-1.023v3.258c-.523-.061-1.164.392-1.633-.267a1.483 1.483 0 0 1-.074-1.533c.249-.553.749-.518 1.245-.435z",
    transform: "translate(-9.424 -10.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3196",
    d: "M273.184 265.63H271.6c.171.768.229.789 1.415.583-.09.489-.363.638-1.011.554a1.163 1.163 0 0 1-1.01-1.31 1.118 1.118 0 0 1 1.129-1.124c.662-.047.977.336 1.061 1.297z",
    className: "cls-3",
    transform: "translate(-18.172 -10.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3197",
    fill: "#738189",
    d: "M224.148 266.752c-.161.325.052.657-.328 1.008v-3.208c.528.034 1.2-.412 1.641.339a1.482 1.482 0 0 1-.012 1.53c-.308.547-.812.393-1.301.331z",
    transform: "translate(-2.733 -10.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3198",
    fill: "#75838a",
    d: "M237.359 265.76l-1.427.067c.194.963.8.576 1.353.335a.869.869 0 0 1-1.2.605c-.7-.274-.739-.883-.622-1.485a.935.935 0 0 1 1.1-.825c.737.095.837.629.796 1.303z",
    transform: "translate(-6.525 -10.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3199",
    d: "M242.824 265.753l-1.4.075c.129.915.782.534 1.4.441a.954.954 0 0 1-1.4.41c-.636-.339-.613-.988-.421-1.565a.908.908 0 0 1 1.143-.644c.663.159.785.641.678 1.283z",
    className: "cls-10",
    transform: "translate(-8.318 -10.717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3200",
    d: "M228.059 266.807a1.047 1.047 0 0 1-1.05-1.228 1.1 1.1 0 0 1 1.067-1.168 1.137 1.137 0 0 1 1.053 1.267 1.022 1.022 0 0 1-1.07 1.129z",
    className: "cls-10",
    transform: "translate(-3.776 -10.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3201",
    fill: "#0b79c5",
    d: "M269.812 266.112c.053.632-.384.61-.71.65a1.1 1.1 0 0 1-1.325-.766 1.2 1.2 0 0 1 .486-1.479c.509-.34 1.038-.246 1.62.326-.692.129-1.9-.42-1.6.961.191.896.93.471 1.529.308z",
    transform: "translate(-17.094 -10.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    d: "M252.82 267.534c1.553-1.061-.138-2.012.1-2.99.21.037.291.153.875 1.313.371-.391.149-1.136.961-1.534a18.278 18.278 0 0 1-1.038 3.014c-.129.297-.426.448-.898.197z",
    className: "cls-5",
    transform: "translate(-12.224 -10.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    fill: "#3e4040",
    d: "M239.435 235.929c-.138.3-.414.1-.614.168a.747.747 0 0 1-.512.2c-.046.03-.142-.04-.148.073a1.111 1.111 0 0 0 .143.018.71.71 0 0 1 .49.193.384.384 0 0 1 0 .141c-.122.185-.319.2-.508.223-.313-.056-.459.292-.738.313a.205.205 0 0 1-.087-.12c.01.082.1.143.064.24a.452.452 0 0 1-.743-.07 1.672 1.672 0 0 0-.8-.465c-.318-.49.317-.273.316-.373.128-.289-.181-.352-.065-.533.066-.149-.109-.383.162-.461a.285.285 0 0 0 .484.017c.172.164.087.64.568.433.277-.31-.134-.8.241-1.109.345.2-.021.848.566.9.2.008.393.008.59.013a.819.819 0 0 1 .591.199z",
    transform: "translate(-6.685 -1.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    fill: "#0676c4",
    d: "M278.3 264.235c-.108.4-.4.207-.487.393-.1.649-.164 1.273.589 1.64-.743.292-1.067.073-1.116-.667-.056-.841-.09-.977-.3-1.21-.042-.233.305-.193.295-.42a2.752 2.752 0 0 1 .051-.461c.713-.118.223 1.007.968.725z",
    transform: "translate(-20.134 -10.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    fill: "#2085ca",
    d: "M275.166 266.723c-.589-.1-.7-.769-.465-2.227.222-.225.388.079.577.06s.355-.242.636-.158c.268.449-.163.475-.406.6-.317.168-.312.48-.335.765-.026.316-.007.637-.007.96z",
    transform: "translate(-19.348 -10.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3206",
    fill: "#afb8be",
    d: "M235.288 236.48c.144.226.452.093.629.249.026.771-.723.2-.905.57.055.293-.026.433-.344.308-.408-.583-1.113-.708-1.662-1.07z",
    transform: "translate(-5.739 -1.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3207",
    fill: "#818d94",
    d: "M239.093 266.786a5.583 5.583 0 0 1-.225-2.232c.431.061.823-.287 1.275.182-1.317.276-.552 1.377-1.05 2.05z",
    transform: "translate(-7.658 -10.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    d: "M262.05 266.844a1.929 1.929 0 0 1 0-2.449z",
    className: "cls-17",
    transform: "translate(-15.102 -10.704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3209",
    d: "M266.666 266.769V264.5c.527-.111.471.254.443.517-.063.6.206 1.277-.178 1.8z",
    className: "cls-17",
    transform: "translate(-16.756 -10.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3210",
    fill: "#52524e",
    d: "M239.335 233.457c.292-.291.671-.006 1.054-.224.048-.33.218-.668.739-.564.085 0 .123.042.112.126v.543a.128.128 0 0 1-.121.121h-.408c-.252.18.04.527-.291.616-.226-.442-.755-.355-1.085-.618z",
    transform: "translate(-7.811 -.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3211",
    fill: "#bac3ca",
    d: "M282.758 237.64l-.344.114c-.246-.276-.014-.629-.252-.871-.41.164-.035.623-.379.846-.323-.286.026-.823-.406-1.034.4-.353.728-.048 1.06-.055.206.185.182.5.4.681a.294.294 0 0 1-.079.319z",
    transform: "translate(-21.571 -1.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    fill: "#30302e",
    d: "M239.3 233.85h.882c.281.191.2.416.207.618l-.474.05a.55.55 0 0 1-.523.088.307.307 0 0 1-.155-.148z",
    transform: "translate(-7.781 -.707)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3213",
    fill: "#fbca24",
    d: "M241.986 233.787l.121-.121c.525-.069.78.106.591.71-.523.167-.798.024-.712-.589z",
    transform: "translate(-8.674 -.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    fill: "#fbca25",
    d: "M242.106 232.481l-.112-.126c-.059-.492.083-.777.657-.623.176.2.088.426.08.63-.208.184-.431.091-.625.119z",
    transform: "translate(-8.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    fill: "#2c2c2a",
    d: "M239.047 235.911c-.9-.046-.334-.743-.5-1.115l.457-.042.03.038a.845.845 0 0 1 .2.625.773.773 0 0 1-.187.494z",
    transform: "translate(-7.545 -1.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    fill: "#afb9c2",
    d: "M283.43 237.631l.009-.338c.009-.1.1-.132.151-.194a.876.876 0 0 1 .344-.6 1.227 1.227 0 0 1-.01 1.273c-.087-.046-.07-.157-.132-.22-.081.063-.119.159-.2.218z",
    transform: "translate(-22.243 -1.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3217",
    fill: "#eeb802",
    d: "M239.336 235.451l-.05-.642.648.022-.017.612-.076.081a.4.4 0 0 1-.505-.073z",
    transform: "translate(-7.795 -1.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3218",
    fill: "#2989cc",
    d: "M278.991 263.127c.308-.028.5.091.5.32a.338.338 0 0 1-.441.316c-.25-.185-.231-.39-.059-.636z",
    transform: "translate(-20.747 -10.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3219",
    fill: "#272726",
    d: "M240.809 236.234h-.63a.364.364 0 0 1 .019-.489h-.017l.651.012z",
    transform: "translate(-8.059 -1.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3220",
    fill: "#b1bbc3",
    d: "M283.434 237.152l-.151.194c-.305-.122-.337-.382-.331-.661.448-.143.215.421.482.467z",
    transform: "translate(-22.086 -1.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    d: "M266.838 263.077c.147.013.255.076.25.241a.236.236 0 0 1-.248.25c-.165.006-.235-.1-.242-.25a.211.211 0 0 1 .24-.241z",
    className: "cls-29",
    transform: "translate(-16.734 -10.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3222",
    d: "M261.858 263.083c.157-.017.259.043.263.211 0 .143-.04.264-.212.273a.231.231 0 0 1-.272-.221c-.02-.164.063-.246.221-.263z",
    className: "cls-29",
    transform: "translate(-15.109 -10.274)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3223",
    fill: "#3f3f3d",
    d: "M237.124 235.812c-.014.182.019.421-.25.412s-.22-.25-.234-.429z",
    transform: "translate(-6.929 -1.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3224",
    fill: "#ced3d9",
    d: "M283.673 238.148a.7.7 0 0 1 .237-.494c.174.142.053.336.094.5z",
    transform: "translate(-22.322 -1.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3225",
    d: "M237.953 237.677l.593-.03 22.429.011a7.26 7.26 0 0 1 .3 14.514c-8.713.069-17.427.013-26.139.007a8.908 8.908 0 0 0 3.729-5.424 8.493 8.493 0 0 0-1.71-7.247c.262-.608.538-1.218.798-1.831z",
    className: "cls-32",
    transform: "translate(-6.435 -1.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3226",
    d: "M230.209 242.273a5.88 5.88 0 0 1 .289 6.122 5.822 5.822 0 1 1-2.739-8.091c.273.124.627.172.727.541a1.246 1.246 0 0 1-.429.869 11.077 11.077 0 0 0-1.643 2.659c-.219.389-.318.863-.834 1.17-1.187-.805-1.821-2.454-3.483-2.657-.284.449.005.681.2.912a15.245 15.245 0 0 1 2.583 4.346c.178.449.44.817.988.807.521-.01.732-.39.892-.807a36.294 36.294 0 0 1 2.443-4.794 3.258 3.258 0 0 1 1.006-1.077z",
    className: "cls-32",
    transform: "translate(-1.341 -2.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3227",
    fill: "#1d1d1b",
    d: "M231.217 241.577a30.188 30.188 0 0 0-3.417 6.323.862.862 0 0 1-.85.615 1.006 1.006 0 0 1-1.061-.574 15.725 15.725 0 0 0-3.049-5.068.594.594 0 0 1-.054-.812c.2-.248.475-.164.739-.054a6.227 6.227 0 0 1 2.25 1.785c.281.32.544.656.857 1.037.416-.8.851-1.526 1.179-2.3a14.494 14.494 0 0 1 1.681-2.382c.25-.237.174-.84.783-.566l.059-.819c.17-.222.392-.129.6-.124a2.869 2.869 0 0 0 .219.215 1.725 1.725 0 0 0-.23-.2c.069-.248-.068-.607.359-.659.281.083.3-.129.344-.308h.72c.261.22.221 1 .854.482.182-.216.256-.583.667-.482v1.251c-.595-.221-.428.5-.8.581-.523.078-.451.663-.753.963-.267.266-.8.505-.8 1.042a1.432 1.432 0 0 1-.297.054z",
    transform: "translate(-2.35 -1.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3228",
    fill: "#323332",
    d: "M239.244 236.717h.638l-.026.481h-.616a.339.339 0 0 1 .004-.481z",
    transform: "translate(-7.747 -1.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3229",
    fill: "#f6fafc",
    d: "M264.1 266.5a.7.7 0 0 1-.571-.794c.013-.424.215-.726.684-.686.486.041.575.431.551.813-.019.36-.18.667-.664.667z",
    transform: "translate(-15.73 -10.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3230",
    fill: "#f7fafc",
    d: "M259.806 265.586c.045.626-.143.973-.566 1-.5.034-.68-.4-.674-.809.006-.369.145-.76.636-.758a.567.567 0 0 1 .604.567z",
    transform: "translate(-14.105 -10.909)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3231",
    d: "M250.24 265.833c0-.382-.021-.808.535-.79.474.015.521.406.525.758 0 .377-.017.816-.531.833-.541.018-.534-.412-.529-.801z",
    className: "cls-37",
    transform: "translate(-11.38 -10.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3232",
    d: "M246.009 265.8c-.018.359.094.828-.475.831-.512 0-.562-.421-.558-.805s.05-.8.574-.79.45.425.459.764z",
    className: "cls-37",
    transform: "translate(-9.657 -10.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3233",
    fill: "#eff6fb",
    d: "M272.991 265.475h-1.108c.362-.675.617-.683 1.108 0z",
    transform: "translate(-18.464 -10.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3234",
    fill: "#f9fafa",
    d: "M225.313 265.709c0 .507-.081.9-.562.935-.539.04-.562-.372-.561-.774 0-.387-.028-.811.509-.834.516-.023.565.391.614.673z",
    transform: "translate(-2.854 -10.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3235",
    fill: "#e6e9ea",
    d: "M237.139 265.553a1.242 1.242 0 0 1-.91.015c-.1-.375.152-.489.424-.529.319-.048.5.113.486.514z",
    transform: "translate(-6.787 -10.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3236",
    fill: "#e7e9eb",
    d: "M241.441 265.5c.538-.527.871-.679 1.169-.013-.368.256-.686.175-1.169.013z",
    transform: "translate(-8.5 -10.916)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3237",
    fill: "#fbfcfc",
    d: "M228.89 265.792c0 .442-.107.816-.577.85-.5.036-.613-.358-.616-.755s.044-.857.6-.853c.503.004.574.394.593.758z",
    transform: "translate(-4.002 -10.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3238",
    fill: "#e3e3e3",
    d: "M239.939 235.748l-.019.489h-.62l.039-.478z",
    transform: "translate(-7.8 -1.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3239",
    fill: "#9ca6ad",
    d: "M239.047 236.713v.488c-.209.039-.468.129-.5-.192-.047-.409.279-.285.5-.296z",
    transform: "translate(-7.55 -1.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3240",
    fill: "#e4e4e4",
    d: "M238.061 238.169c-.206-.024-.5.133-.546-.234-.028-.2.095-.272.279-.27.394 0 .258.291.271.5z",
    transform: "translate(-7.214 -1.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3241",
    d: "M246.4 249.767l-1.862-3.618v3.633h-1.141v-5.546h1.337l1.6 3 .153-.013v-2.948a2.383 2.383 0 0 1 1.175-.021v5.511z",
    className: "cls-46",
    transform: "translate(-9.139 -4.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3242",
    d: "M261.444 248.889c.266.321.523.113.749.173a1.565 1.565 0 0 1 .2.762c-1.549.581-2.246.1-2.247-1.53v-1.514c-1.251-.149-1.75.272-1.773 1.459-.01.558 0 1.116 0 1.7h-1.22V245.9c.192-.183.428-.1.691-.069l.327.7a1.984 1.984 0 0 1 1.9-.72 2.846 2.846 0 0 0 .288-1.078 1.509 1.509 0 0 1 1.027-.033v.918c.235.313.553.078.809.246.149.22.069.483.045.739-.222.219-.527.027-.793.176z",
    className: "cls-46",
    transform: "translate(-13.641 -4.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3243",
    fill: "#1f1f1d",
    d: "M272.914 250.472h-1.171v-4.082c.522-.248.788.026.959.483a6.455 6.455 0 0 1 .542-.385 1.4 1.4 0 0 1 2.225 1.128c.069.929.014 1.867.014 2.838h-1.226c0-.772-.008-1.54 0-2.309.007-.448-.081-.848-.616-.84-.5.008-.751.311-.735.845.026.75.008 1.496.008 2.322z",
    transform: "translate(-18.418 -4.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3244",
    d: "M250.32 248.374a2.1 2.1 0 0 1 2.181-2.1 2.161 2.161 0 0 1 2.15 2.159 2.188 2.188 0 0 1-2.254 2.147 2.119 2.119 0 0 1-2.077-2.206z",
    className: "cls-46",
    transform: "translate(-11.406 -4.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3245",
    d: "M267.075 246.28a2.153 2.153 0 1 1-2.155 2.118 2.1 2.1 0 0 1 2.155-2.118z",
    className: "cls-46",
    transform: "translate(-16.185 -4.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    d: "M234.942 239.129h.619c.1.264.173.523-.167.575-.453.07-.368-.334-.441-.588z",
    className: "cls-48",
    transform: "translate(-6.373 -2.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3247",
    d: "M235.627 241.508c.045.292.137.558-.245.586a.29.29 0 0 1-.342-.342c.03-.377.294-.293.587-.244z",
    className: "cls-48",
    transform: "translate(-6.405 -3.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3248",
    d: "M254.086 248.956a1.131 1.131 0 0 1-1.079 1.076 1.075 1.075 0 0 1 .007-2.149 1.1 1.1 0 0 1 1.072 1.073z",
    className: "cls-37",
    transform: "translate(-11.944 -5.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3249",
    fill: "#fbfbfb",
    d: "M267.6 250.033a1.1 1.1 0 0 1-1.08-1.068 1.072 1.072 0 0 1 1.059-1.08 1.1 1.1 0 0 1 1.091 1.058 1.127 1.127 0 0 1-1.07 1.09z",
    transform: "translate(-16.709 -5.3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorton);
export default __webpack_public_path__ + "static/media/norton.56f70c286ed788318b10773b178785d1.svg";
export { ForwardRef as ReactComponent };